<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <p>
        Varsayılan olarak aktif ürünler listelenir. Pasif ürünleri listelemek
        için filtreyi temizleyin.
      </p>
      <CustomerProductForm ref="customerProductForm" @saved="loadList" />
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        add-route="#"
        @click:add="handleAddClick"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <a
        class="btn btn-icon btn-sm btn-clean"
        href="#"
        @click.prevent="handleEditClick(item)"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </a>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.customer_name="{ item }">
      <router-link
        :to="{
          name: 'admin.crm.customers.edit',
          params: {
            id: item.customer_id,
          },
        }"
      >
        {{ item.customer_name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.product_name="{ item }">
      <router-link
        :to="{
          name: 'admin.products.edit',
          params: {
            id: item.product_id,
          },
        }"
      >
        {{ item.product_name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_yearly="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_active="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.amount="{ value }">
      <rs-table-cell-number price :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.starts_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.ends_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <rs-table-button-delete
        @deleted="handleDeleteClick(item)"
        confirmed
        :loading="isLoading"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <!-- <template v-slot:item.removed_at="{ value, item }">
      <rs-table-cell-date show-time :value="value" v-if="value" />
      <rs-table-button-delete
        v-else
        @deleted="handleDeleteConfirmed(item)"
        :loading="isLoading"
        confirmed
        label="Kaldır"
      />
    </template> -->
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";
import { mapGetters } from "vuex";
import { CustomerProductForm } from "../components";

export default {
  name: "AdminCustomerProductList",
  components: {
    CustomerProductForm,
  },
  mixins: [hasDataTable],
  props: {
    customerId: {
      type: Number,
      required: false,
    },
    productId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    userId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["roleList"]),
  },
  data() {
    return {
      options: {
        sortBy: ["ends_on"],
        sortDesc: [false],
      },
      search: {
        is_active: true,
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "Müşteri",
          value: "customer_name",
          searchable: "text",
          hide: () => this.customerId,
        },
        {
          text: "Ürün",
          value: "product_name",
          searchable: "text",
          hide: () => this.productId,
        },
        {
          text: "Başlangıç",
          value: "starts_on",
          searchable: "date",
        },
        {
          text: "Bitiş",
          value: "ends_on",
          searchable: "date",
        },
        {
          text: "Tutar / BB",
          value: "amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Durum",
          value: "is_active",
          searchable: "isActive",
        },
        {
          text: "Yıllık",
          value: "is_yearly",
          searchable: "yesNo",
          align: "center",
        },
        {
          text: null,
          value: "actions",
          searchable: false,
          sortable: false,
          align: "right",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.customerId) {
        params.customer_id = this.customerId;
      }

      if (this.productId) {
        params.product_id = this.productId;
      }

      return this.$api
        .query("api-super-admin/customer-products", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleAddClick() {
      this.$refs.customerProductForm.show(this.customerId, this.productId);
    },
    handleEditClick(item) {
      this.$refs.customerProductForm.show(null, null, item.id);
    },
    handleDeleteClick(item) {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;

      return this.$api
        .delete(`api-super-admin/customer-products/${item.id}`)
        .then(() => {
          this.$toast.success(this.$t("toasts.item_deleted"));
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        })
        .then(() => {
          this.loadList();
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
